module.exports = __webpack_public_path__ + "img/map_Z2.7.A.01.3a2e478d.svg";